import styled from 'styled-components';
export const EmptyStateContainer = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-500);
`;
